import { render } from "./ModalServerError.vue?vue&type=template&id=737487cf&scoped=true"
import script from "./ModalServerError.vue?vue&type=script&lang=js"
export * from "./ModalServerError.vue?vue&type=script&lang=js"

import "./ModalServerError.vue?vue&type=style&index=0&id=737487cf&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737487cf"]])

export default __exports__